import { sendRequest } from 'services/api';

const ROUTES = {
    GET_PRICEBOOKS: { path: '/pricebooks', method: 'get', isRodx: true },
    SEARCH_PRICEBOOKS: { path: '/pricebooks/search', method: 'post', isRodx: true },
    ESTIMATE: { path: '/estimate', method: 'post', isRodx: true },
    GET_PRICEBOOK_RULES: { path: '/pricebook/:id/rules', method: 'get', isRodx: true },
    ADD_PRICEBOOK_RULE: { path: '/pricebook/:id/rule', method: 'post', isRodx: true },
    UPDATE_PRICEBOOK_RULE: { path: '/pricebook/:id/rule/:ruleId', method: 'put', isRodx: true },
    DELETE_PRICEBOOK_RULE: { path: '/pricebook/:id/rule/:ruleId', method: 'delete', isRodx: true },
    GET_VEHICLE_MAKES: { path: '/vehicles/makes', method: 'get', isRodx: true },
    GET_VEHICLE_MODELS: { path: '/vehicles/models', method: 'get', isRodx: true },
    GET_DOCUMENTATION: { path: '/pricebook/documentation', method: 'get', isRodx: true },
};

export const getPricebooks = async function() {
    return sendRequest(ROUTES.GET_PRICEBOOKS);
};

export const searchPricebooks = async function(searchParams) {
    return sendRequest(ROUTES.SEARCH_PRICEBOOKS, '', searchParams);
};

export const getPricebookRules = async function(pricebookId) {
    const route = { ...ROUTES.GET_PRICEBOOK_RULES };
    route.path = route.path.replace(':id', pricebookId);
    return sendRequest(route);
};

export const addPricebookRule = async function(pricebookId, ruleData) {
    const route = { ...ROUTES.ADD_PRICEBOOK_RULE };
    route.path = route.path.replace(':id', pricebookId);
    return sendRequest(route, '', ruleData);
};

export const updatePricebookRule = async function(pricebookId, ruleId, ruleData) {
    const route = { ...ROUTES.UPDATE_PRICEBOOK_RULE };
    route.path = route.path.replace(':id', pricebookId).replace(':ruleId', ruleId);
    return sendRequest(route, '', ruleData);
};

export const deletePricebookRule = async function(pricebookId, ruleId) {
    const route = { ...ROUTES.DELETE_PRICEBOOK_RULE };
    route.path = route.path.replace(':id', pricebookId).replace(':ruleId', ruleId);
    return sendRequest(route);
};

export const estimate = async function(estimateData) {
    return sendRequest(ROUTES.ESTIMATE, '', estimateData);
};

export const getVehicleMakes = async function() {
    return sendRequest(ROUTES.GET_VEHICLE_MAKES);
};

export const getVehicleModels = async function(makes) {
    // If makes are provided, call GET with query string to filter
    if (Array.isArray(makes) && makes.length > 0) {
        // Send as comma-separated list in a single query parameter
        const makesParam = makes.map(m => encodeURIComponent(m)).join(',');
        const route = { ...ROUTES.GET_VEHICLE_MODELS, path: `${ROUTES.GET_VEHICLE_MODELS.path}?makes=${makesParam}` };
        return sendRequest(route);
    }
    return sendRequest(ROUTES.GET_VEHICLE_MODELS);
};

export const getDocumentation = async function() {
    return sendRequest(ROUTES.GET_DOCUMENTATION);
};

export default {
    getPricebooks,
    searchPricebooks,
    estimate,
    getPricebookRules,
    addPricebookRule,
    updatePricebookRule,
    deletePricebookRule,
    getVehicleMakes,
    getVehicleModels,
    getDocumentation,
};
